import { toast } from 'react-toastify';
import { all, put, takeLatest } from 'redux-saga/effects';
import * as service from '../../services/order.service';
import { getCompletedOrdersSuccess } from '../slice';
import { GET_COMPLETED_ORDER_REQUEST } from '../types';

function* getCompletedOrdersRequestSaga(action) {
    try {
        const { hotelId, params = {} } = action.payload;
        const result = yield service.getCompletedOrders({ hotelId, ...params });
        yield put(getCompletedOrdersSuccess(result));
    } catch (error) {
        console.error('Failed to get table completed orders', error);
        toast.error(`Failed to get table completed orders ${error.message}`);
    }
}

// function* updateOrderStatusRequestSaga(action) {
//     try {
//         const { data } = action.payload;
//         const res = yield service.updateOrdersStatus(data);
//         if (res.feedback) {
//             yield put(setFeedback({
//                 data: {
//                     customerId: data.customerId,
//                     adminView: true,
//                     hotelId: data.hotelId,
//                     tokenId: res.tokenId
//                 },
//                 show: true
//             }));
//         } else {
//             yield put(getActiveOrders({ hotelId: data.hotelId }));
//         }

//         toast.success('Orders status updated successfully');
//     } catch (error) {
//         console.error('Failed to update table orders', error);
//         toast.error(`Failed to update table orders ${error.message}`);
//     }
// }

export default function* orderSaga() {
    yield all([takeLatest(GET_COMPLETED_ORDER_REQUEST, getCompletedOrdersRequestSaga)]);
    // yield all([takeLatest(UPDATE_ORDER_STATUS_REQUEST, updateOrderStatusRequestSaga)]);
}
